import React from 'react';

export default { useLocalState };

export function useLocalState<T>(
  name: string,
  default_value: T
): [T, (T) => void] {
  const key = 'local-state-' + name;
  const found = _parse(window.localStorage[key]);
  const [value, setValue] = React.useState(found ?? default_value);
  function _setValue(new_value) {
    window.localStorage[key] = JSON.stringify(new_value);
    setValue(new_value);
  }
  return [value, _setValue];
}
function _parse(json: string) {
  let ret;
  try {
    ret = JSON.parse(json);
  } catch {
    // ignore
  }
  return ret;
}
